export class CreateProjectRequest
{
    public name: string;
    public description: string | null;
    public programId: string;
    public cap: string | null;
    public spa: File | null;
}
